import {DebuggingPanel} from "~/components/debuggingPanel";
import type {OttopilotDataViewerController} from "~/components/ottopilotDataViewer/ottopilotDataViewerController";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function DataDebuggingPanel<
    T extends {
        id: Uuid;
    },
>({
    controller,
    viewDataSummary,
    className,
}: {
    controller: OttopilotDataViewerController<T>;
    viewDataSummary?: {
        loadedRowCount: number;
        isLoadingData: boolean;
        hasNextPage: boolean | null;
    };
    className?: string;
    //
}) {
    return (
        <>
            <DebuggingPanel className="max-w-[19rem] max-h-[9rem] overflow-auto">
                <div className="font-bold">OttopilotDataViewer</div>

                <div>
                    Currently loaded:{" "}
                    {viewDataSummary !== undefined ? `${viewDataSummary.loadedRowCount} rows` : "null"}
                </div>

                {/* <div>isLoadingData: {isLoadingData ? "🟢" : "🔴"}</div> */}
                <div>isLoadingData: {viewDataSummary?.isLoadingData === true ? "⏳" : "❌"}</div>

                {/* <div>hasNextPage: {hasNextPage === null ? "🟡" : hasNextPage === true ? "🟢" : "🔴"}</div> */}
                <div>
                    hasNextPage:{" "}
                    {viewDataSummary?.hasNextPage === null
                        ? "⏳"
                        : viewDataSummary?.hasNextPage === true
                        ? "✅"
                        : "❌"}
                </div>
            </DebuggingPanel>

            <DebuggingPanel className="left-[20rem] max-w-[19rem] max-h-[19rem] overflow-auto">
                <div className="font-bold">OttopilotDataViewer: filterConfiguration</div>
                <div className="whitespace-pre">{JSON.stringify(controller.filterConfiguration, null, 4)}</div>
            </DebuggingPanel>

            <DebuggingPanel className="left-[40rem] max-w-[19rem] max-h-[19rem] overflow-auto">
                <div className="font-bold">OttopilotDataViewer: sortConfiguration</div>
                <div className="whitespace-pre">{JSON.stringify(controller.sortConfiguration, null, 4)}</div>
            </DebuggingPanel>
        </>
    );
}
